
import Footer from '../components/footer.vue'
import {
SaunaKanbanQuery,
GetLeftUpInfo
} from '../../static/js/api.js'
import querystring from 'vux/src/tools/querystring/index.js'

function loadtotal(that) {

GetLeftUpInfo({}, function (res) {
console.log(res)
if (res.data.state==1) {

that.my = res.data.doc


console.log(that.my)
} else {

that.$vux.toast.text('您不是员工，请管理员录入', 'middle')

}


})

SaunaKanbanQuery({}, function (res) {
console.log(res)
if (res.data.IsSuccess) {

that.data = JSON.parse(res.data.Result)
that.loading=false

console.log(that.data)
} else {

that.$vux.toast.text('数据获取失败，请重试', 'middle')

}


})

}


export default {
name: 'app',
components: {
'pc-footer': Footer,
},
data() {
return {
loading:true,

my:{
name:"***",
company:{
name:"***"
}
},
data: {
GuestFlows: {},
BarConsumeDetails: {},
BarConsumeSummary: {},
ConsumeDetails: {},
ConsumeSummary: {},
GuestPerConsume: {},
HandCardUsed: {},
MemberUsedDetail: {},
MemberUsedSummary: {},
NewMemberDetails: {},
NewMemberSummary: {},
PayModeDetails: {},
PayModeSummary: {
Money:1
},
PrepaidMemberDetails: {},
PrepaidMemberSummary: {},


},
msg: 'Welcome to Your Vue.js App',
nav: [
{
link:'/yingyun',
name:'当前营业',
img:require('../assets/CRM_icon_dqyy.png'),

},
{
link:'/jiaoban',
name:'已交班',
img:require('../assets/CRM_icon_yjb.png'),

},
{
link:'/yichang',
name:'异常报表',
img:require('../assets/CRM_icon_ycbb.png'),

},
{
link:'/hjyingyun',
name:'会籍营业',
img:require('../assets/CRM_icon_hjyy.png'),

},
{
link:'/hjjiaoban',
name:'会籍交班',
img:require('../assets/CRM_icon_kjjb.png'),

},
{
link:'/hjyichang',
name:'会员卡套现',
img:require('../assets/CRM_icon_hyktx.png'),

},
{
link:'/hjyichangcard',
name:'会员卡消费',
img:require('../assets/CRM_icon_hykxf.png'),

},
{
link:'/hjyichangzhuan',
name:'会员卡转账',
img:require('../assets/CRM_icon_hykzz.png'),

}

],
selectedsr:1,
navsr:[

{
id:1,
name:"会员办卡"

},
{
id:2,
name:"会员续费"

}

]
}
},
computed:{

people(){
var people=0;
for(var i=0;i<this.data.HandCardUsed.length;i++){
var item=this.data.HandCardUsed[i]
people+=item.Used

}

people = people.toFixed(0)
return people
}


},
mounted(){



},
created() {



var that = this
loadtotal(that)


},
methods:{

refresh(){
this.loading=true
var that=this
loadtotal(that)


},

changesr(index){
console.log(index)
this.selectedsr= parseInt(index+1)

}




}

}



// WEBPACK FOOTER //
// ./src/pages/mainclass.vue